var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useErrorHandler } from './useErrorHandler';
export const useAsyncExecAction = () => {
    const { errorHandler: innerErrorHandler } = useErrorHandler();
    const execAsyncAction = ({ action, errorHandler = null, final = null, log = true }) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield action();
            return true;
        }
        catch (e) {
            if (log)
                console.error(e.response);
            if (errorHandler) {
                errorHandler(e);
            }
            else {
                innerErrorHandler(e);
            }
            return false;
        }
        finally {
            final === null || final === void 0 ? void 0 : final();
        }
    });
    return {
        execAsyncAction,
    };
};
